import axios from 'axios';
import { loginreq,loginreq2, req ,account,httppoo} from './axiosFun';
	  let commonConfig = {};
	  //commonConfig.host ="http://112.53.144.42:16001/" 
	  commonConfig.host ="https://rifengczyxzx.com/"
	  //"http://81.69.20.103:8001/" 
	  // "http://47.101.209.193:8001/";
	  //  "http://172.18.84.14:8001/"
	 // commonConfig.host ="http://192.168.3.101:8001/";
//commonConfig.host ="http://192.168.100.10:8001/";
commonConfig.ExecuteSQL = commonConfig.host + "YPSoftAppService.asmx/ExecuteJasonApp";
commonConfig.SetGridData = commonConfig.host + "YPSoftAppService.asmx/GetGridData";
commonConfig.getLIst = commonConfig.host + "YPSoftAppService.asmx/GetItemClassDataApp";
commonConfig.getLIst2 = commonConfig.host + "YPSoftAppService.asmx/GetItemClassDataApp";
commonConfig.ListMenuApp=commonConfig.host + "YPSoftAppService.asmx/ListMenuApp";
commonConfig.ListLItemClassApp=commonConfig.host + "YPSoftAppService.asmx/ListLItemClassApp";
commonConfig.LinkQueryApp=commonConfig.host + "YPSoftAppService.asmx/LinkQueryApp";
commonConfig.LinkUpNextApp=commonConfig.host + "YPSoftAppService.asmx/LinkUpNextApp";
commonConfig.getGrid=commonConfig.host + "YPSoftAppService.asmx/GetGridDes";
commonConfig.InitBill=commonConfig.host + "YPSoftAppService.asmx/InitBill";
commonConfig.OperateBill=commonConfig.host + "YPSoftAppService.asmx/OperateBill";
commonConfig.Model_Sql_PageApp=commonConfig.host + "YPSoftAppService.asmx/Model_Sql_PageApp";
commonConfig.Model_PlugIn_App=commonConfig.host + "YPSoftAppService.asmx/Model_PlugIn_App";
commonConfig.UserLogin_App=commonConfig.host + "YPSoftAppService.asmx/UserLogin_App";
export const getGrid = (params) => { return loginreq("get", commonConfig.getGrid, params) };
// 接口 
export const Model_Sql_PageApp = (params) => { return loginreq("get", commonConfig.Model_Sql_PageApp, params) };
export const PlugInApp = (params) => { return loginreq("get", commonConfig.Model_PlugIn_App, params) };
export const UserLogin = (params) => { return loginreq("get", commonConfig.UserLogin_App, params) };
export const login = (params) => { return loginreq("get", commonConfig.ExecuteSQL, params) };
export const login2 = (params) => { return loginreq2("POST", commonConfig.ExecuteSQL, params) };
export const getLIst= (params) => { return loginreq("get", commonConfig.getLIst, params) };
export const getLIst2= (params) => { return loginreq2("POST", commonConfig.getLIst2, params) };
export const InitBill= (params) => { return loginreq("get", commonConfig.InitBill, params) };
export const  OperateBill= (params) => { return loginreq2("POST", commonConfig.OperateBill, params) };
export const  OperateBill1= (params) => { return loginreq("get", commonConfig.OperateBill, params) };
//加载菜单
export const getMenuApp= (params) => { return loginreq("get", commonConfig.ListMenuApp, params) };

export const Lmenu = (params) => { return loginreq("get", commonConfig.ListMenuApp, params) };
//获取基础资料getListLItemClassApp
export const ListLItemClassApp = (params) => { return loginreq("get", commonConfig.ListLItemClassApp, params) };
//获取列表名，lsysid，网格结构，按钮显示和锁定
export const LinkQueryApp = (params) => { return loginreq("get", commonConfig.LinkQueryApp, params) };
//获取上下查数据
export const LinkUpNextApp = (params) => { return loginreq("get", commonConfig.LinkUpNextApp, params) };
//列表页接口
export const GetLB = (params) => { return req("POST", commonConfig.SetGridData, params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

//获取销售列表
//export const  Paylist =()=>{ return axios.getlIST("get" , commonConfig.ExecuteSQL, params}
/**
 * 用户管理 
 **/
 export const accountset= () =>{return account()};
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/api/User/list", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/api/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理 
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", "/api/Role/list", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/api/Role/save", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };

/**
 * 物料管理 
 **/
// 物料管理-获取物料列表
export const deptList = (params) => { return req("post", "/api/Dept/list", params) };
// 物料管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/api/Dept/save", params) };
// 物料管理-删除物料
export const deptDelete = (params) => { return axios.get("/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 系统环境变量 
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理 
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };


// WEBPACK FOOTER //
// ./src/api/userMG.js